import { AnyAction, Reducer } from 'redux';

export const STORE_CUSTOMERTYPE_PROFILE = 'signupUser/store-customertype';
export const STORE_CUSTOMERNAME_PROFILE = 'signupUser/store-customername';
export const STORE_CUSTOMEREMAIL_PROFILE = 'signupUser/store-customeremail';
export const STORE_CUSTOMERPHONENUMBER_PROFILE = 'signupUser/store-customerphonenumber';
export const STORE_CUSTOMERADDRESSONE_PROFILE = 'signupUser/store-customeraddressone';
export const STORE_CUSTOMERADDRESSTWO_PROFILE = 'signupUser/store-customeraddresstwo';
export const STORE_CUSTOMERCOUNTRY_PROFILE = 'signupUser/store-customercountry';
export const STORE_CUSTOMERSTATE_PROFILE = 'signupUser/store-customerstate';
export const STORE_CUSTOMERPRODUCT_PROFILE = 'signupUser/store-customerproduct';
export const STORE_CUSTOMERSCANNER_PROFILE = 'signupUser/store-customerscanner';
export const STORE_CUSTOMERCONTACTNAME_PROFILE = 'signupUser/store-contactname';
export const STORE_CUSTOMERCONTACTNUMBER_PROFILE = 'signupUser/store-contactnumber';
export const STORE_CUSTOMERCOMMENT_PROFILE = 'signupUser/store-customercomment';
export const STORE_CUSTOMERDSOFT_PROFILE = 'signupUser/store-customerdesignsoftware';
export const STORE_CUSTOMERCUSTDEST_PROFILE = 'signupUser/store-customerdestination';
export const STORE_CUSTOMERCUSTTAT_PROFILE = 'signupUser/store-customertat';

export const STORE_USERPROFILEDATA = 'data/user-profile-from-api';
export const STORE_DESIGNPREF_DATA = 'data/design-prefrence-from-api';
export const STORE_DESIGNSOFTWARES_DATA = 'data/design-softwares-from-api';

export const STORE_DESIGNPREF_OCCULSION = 'occulsion/design-prefrence-from-api';
export const STORE_DESIGNPREF_DESIGNTYPE = 'designtype/design-prefrence-from-api';
export const STORE_DESIGNPREF_CONTACT = 'contact/design-prefrence-from-api';
export const STORE_DESIGNPREF_PONTICDESIGN = 'ponticdesign/design-prefrence-from-api';
export const STORE_DESIGNPREF_MODELTYPE = 'modeltype/design-prefrence-from-api';

export const STORE_CUSTOMEROCCLUSION = 'data/store-occlusion';
export const STORE_CUSTOMERDESIGNTYPE = 'data/store-designtype';
export const STORE_CUSTOMERPONTICDESIGN = 'data/store-ponticdesign';
export const STORE_CUSTOMERCONTACT = 'data/store-contact';
export const STORE_CUSTOMERMODELTYPE = 'data/store-modeltype';
export const STORE_CUSTOMERNOTE = 'data/store-note';
export const STORE_ORDERDATAOCCLUSION = 'data/occlusion-data';

// export interface Occlusiondata {
//     rowno: string,
//     ord: string,
//     fieldname: string,
//     listvalues: string
// }

export interface UserProfileData {
    rowno: string;
    custcode: string;
    custname: string;
    emailid: string;
    phoneno: string;
    address1: string;
    address2: string;
    country: string;
    state: string;
    products: string;
    scanners: string;
    contactname: string;
    contactno: string;
    comments: string;
    dsoft: string;
    destination: string;
    tat: string;
    occlusion: string;
    contact: string;
    designtype: string;
    ponticdesign: string;
    modeltype: string;
    notes: string;
    isbatch: string;
}

export interface DesignPref {
    rowno: string;
    ord: string;
    fieldname: string;
    listvalues: string;
}

export interface DesignSofts {
    recordid?: string;
    name?: string;
    modelprint?: string;
}

export interface UserProfileState {
    userProfiledata: UserProfileData;
    designPref: DesignPref[];
    designSoftwares: DesignSofts[];
    custtype: string;
    custname: string;
    custemail: string;
    custnumber: string;
    custaddressone: string;
    custaddresstwo: string;
    custcountry: string;
    custstate: string;
    custproduct: string;
    custscanner: string;
    custcontactName: string;
    custcontactNumber: string;
    custcomment: string;
    custdsoft: string;
    custdest: string;
    custtat: string;
    occlusion: string;
    contact: string;
    designtype: string;
    ponticdesign: string;
    modeltype: string;
    notes: string;

    occulsionArr: DesignPref[];
    designtypeArr: DesignPref[];
    contactArr: DesignPref[];
    ponticdesignArr: DesignPref[];
    modeltypeArr: DesignPref[];
}

const initialState: UserProfileState = {
    userProfiledata: {
        rowno: '',
        custcode: '',
        custname: '',
        emailid: '',
        phoneno: '',
        address1: '',
        address2: '',
        country: '',
        state: '',
        products: '',
        scanners: '',
        contactname: '',
        contactno: '',
        comments: '',
        dsoft: '',
        destination: '',
        tat: '',
        occlusion: '',
        contact: '',
        designtype: '',
        ponticdesign: '',
        modeltype: '',
        notes: '',
        isbatch: 'F'
    },
    designPref: [],
    designSoftwares: [],
    custtype: '',
    custname: '',
    custemail: '',
    custnumber: '',
    custaddressone: '',
    custaddresstwo: '',
    custcountry: '',
    custstate: '',
    custproduct: '',
    custscanner: '',
    custcontactName: '',
    custcontactNumber: '',
    custcomment: '',
    custdsoft: '',
    custdest: '',
    custtat: '',
    occlusion: '',
    contact: '',
    designtype: '',
    ponticdesign: '',
    modeltype: '',
    notes: '',

    occulsionArr: [],
    designtypeArr: [],
    contactArr: [],
    ponticdesignArr: [],
    modeltypeArr: []
};

const reducer: Reducer<UserProfileState> = (state: UserProfileState = initialState, action: AnyAction): UserProfileState => {
    switch (action.type) {
        case STORE_USERPROFILEDATA:
            return {
                ...state,
                userProfiledata: action.userProfiledata
            };
        case STORE_DESIGNPREF_DATA:
            return {
                ...state,
                designPref: action.designPref
            };
        case STORE_DESIGNPREF_OCCULSION:
            return {
                ...state,
                occulsionArr: action.occulsionArr
            };
        case STORE_DESIGNPREF_DESIGNTYPE:
            return {
                ...state,
                designtypeArr: action.designtypeArr
            };
        case STORE_DESIGNPREF_CONTACT:
            return {
                ...state,
                contactArr: action.contactArr
            };
        case STORE_DESIGNPREF_PONTICDESIGN:
            return {
                ...state,
                ponticdesignArr: action.ponticdesignArr
            };
        case STORE_DESIGNPREF_MODELTYPE:
            return {
                ...state,
                modeltypeArr: action.modeltypeArr
            };
        case STORE_CUSTOMERTYPE_PROFILE:
            return {
                ...state,
                custtype: action.custtype
            };
        case STORE_CUSTOMERNAME_PROFILE:
            return {
                ...state,
                custname: action.custname
            };
        case STORE_CUSTOMEREMAIL_PROFILE:
            return {
                ...state,
                custemail: action.custemail
            };
        case STORE_CUSTOMERPHONENUMBER_PROFILE:
            return {
                ...state,
                custnumber: action.custnumber
            };
        case STORE_CUSTOMERADDRESSONE_PROFILE:
            return {
                ...state,
                custaddressone: action.custaddressone
            };
        case STORE_CUSTOMERADDRESSTWO_PROFILE:
            return {
                ...state,
                custaddresstwo: action.custaddresstwo
            };
        case STORE_CUSTOMERCOUNTRY_PROFILE:
            return {
                ...state,
                custcountry: action.custcountry
            };
        case STORE_CUSTOMERSTATE_PROFILE:
            return {
                ...state,
                custstate: action.custstate
            };
        case STORE_CUSTOMERPRODUCT_PROFILE:
            return {
                ...state,
                custproduct: action.custproduct
            };
        case STORE_CUSTOMERSCANNER_PROFILE:
            return {
                ...state,
                custscanner: action.custscanner
            };
        case STORE_CUSTOMERCONTACTNAME_PROFILE:
            return {
                ...state,
                custcontactName: action.custcontactName
            };
        case STORE_CUSTOMERCONTACTNUMBER_PROFILE:
            return {
                ...state,
                custcontactNumber: action.custcontactNumber
            };
        case STORE_CUSTOMERCOMMENT_PROFILE:
            return {
                ...state,
                custcomment: action.custcomment
            };
        case STORE_CUSTOMERDSOFT_PROFILE:
            return {
                ...state,
                custdsoft: action.custdsoft
            };
        case STORE_CUSTOMERCUSTDEST_PROFILE:
            return {
                ...state,
                custdest: action.custdest
            };
        case STORE_CUSTOMERCUSTTAT_PROFILE:
            return {
                ...state,
                custtat: action.custtat
            };
        case STORE_DESIGNSOFTWARES_DATA:
            return {
                ...state,
                designSoftwares: action.designSoftwares
            };
        case STORE_CUSTOMEROCCLUSION:
            return {
                ...state,
                occlusion: action.occlusion
            };
        case STORE_CUSTOMERDESIGNTYPE:
            return {
                ...state,
                designtype: action.designtype
            };
        case STORE_CUSTOMERPONTICDESIGN:
            return {
                ...state,
                ponticdesign: action.ponticdesign
            };
        case STORE_CUSTOMERCONTACT:
            return {
                ...state,
                contact: action.contact
            };
        case STORE_CUSTOMERMODELTYPE:
            return {
                ...state,
                modeltype: action.modeltype
            };
        case STORE_CUSTOMERNOTE:
            return {
                ...state,
                notes: action.notes
            };
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/userProfile.tsx